import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'
import styles from './Search.module.scss'
import { Input } from '@/components/Input/Input'
import SearchIcon from '@mui/icons-material/Search'
import { Button } from '@/ui'
import { Icon } from '@/components/Icon'
import { CrossIcon } from '@app/icons'

export const Search = ({ onSearch, onReset }) => {
	const { t } = useTranslation()

	const [searchText, setSearchText] = useState('')

	const handleSearch = (searchQuery) => {
		const normalized = searchQuery.trim()
		if (normalized.length < 12) return
		if (onSearch) {
			onSearch(normalized)
		}
	}

	const handleReset = () => {
		setSearchText('')
		if (onReset) {
			onReset()
		}
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleSearch(searchText)
		}
	}

	const handleInputChange = (e) => {
		const digits = e.target.value.replace(/\D/g, '').slice(0, 12)
		setSearchText(digits)
	}

	return (
		<div className={styles.wrapper}>
			<Input
				prefix={<SearchIcon />}
				containerClassName={styles.inputClass}
				placeholder={t('staff.search_placeholder')}
				onChange={handleInputChange}
				value={searchText}
				onKeyDown={handleKeyDown}
				postfix={
					searchText && (
						<button type="button" className={styles.clearButton} onClick={handleReset}>
							<Icon component={CrossIcon} className={styles.clearIcon} />
						</button>
					)
				}
			/>

			<Button onClick={() => handleSearch(searchText)} disabled={searchText.trim().length < 12}>
				{t('find')}
			</Button>
		</div>
	)
}
